import { InstanceType, Model, NodeType } from './types';
import { generateDNA } from './DNA';
import { mat4, vec3, vec4 } from 'gl-matrix';
import { generateQuadcopter } from './Quadcopter';

export const generateSceneModel = (): Model => ({
  name: "Assignment 4 Model",
  scene: {
    name: "Scene",
    edges: [{
      to: generateDNA(),
      toType: NodeType.GROUP_NODE,
      transformation: mat4.translate(mat4.create(), mat4.create(), vec3.fromValues(500, 0, 0)),
    }, {
      to: generateQuadcopter(),
      toType: NodeType.GROUP_NODE,
      transformation: mat4.translate(mat4.create(), mat4.create(), vec3.fromValues(-500, 0, 0)),
    }]
  },
  sceneNodeType: NodeType.GROUP_NODE,
});

export const generateTestSceneModel = (): Model => ({
  name: "TEST Model",
  scene: {
    name: "Test Scene",
    edges: [{
      to: {
        name: 'TEST SEMI',
        instance: InstanceType.SEMI_SPHERE,
        color: vec4.fromValues(0, 1, 0, 1),
      },
      toType: NodeType.LEAF_NODE,
      transformation: mat4.scale(mat4.create(), mat4.translate(mat4.create(), mat4.create(), vec3.fromValues(100, 0, 0)), vec3.fromValues(100, 100, 100)),
    }]
  },
  sceneNodeType: NodeType.GROUP_NODE,
});